import { render, staticRenderFns } from "./goodsAnalysis.vue?vue&type=template&id=217af4e4&"
import script from "./goodsAnalysis.vue?vue&type=script&lang=js&"
export * from "./goodsAnalysis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports